import React, { ReactNode } from 'react';
import * as Sentry from '@sentry/browser';
import { GlobalStyles, helperMargin, Typography } from '@dizraptors/ui-kit';

import { Container, CactusImage, CodeError } from './styles';
import srcCactusImage from './static/img/cactus.svg';
import { globalStyles } from '../../styles';

interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  errorId: string | null;
  children?: ReactNode;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      errorId: null
    };
  }

  static getDerivedStateFromError(error: unknown) {
    Sentry.captureException(error);

    return {
      hasError: true,
      errorId: Sentry.lastEventId()
    };
  }

  render() {
    const { children } = this.props;
    const { hasError, errorId } = this.state;

    if (hasError) {
      return (
        <>
          <GlobalStyles styles={[globalStyles]} fonts={['inter', 'grafier']} />

          <Container>
            <CactusImage src={srcCactusImage} alt="" />

            <Typography.Paragraph size="Dizraptor/Title XXL" css={helperMargin({ bottom: 10 })}>
              Oops! Something went wrong. <br />
              Please refresh the page
            </Typography.Paragraph>

            <CodeError>{errorId}</CodeError>
          </Container>
        </>
      );
    }

    return children;
  }
}
